import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Output, ViewChild } from '@angular/core';
import { AlertModalComponent } from '@components/alert-modal/alert-modal.component';
import { LOYALTY_ONLY_WARNING_MODAL_TEXT } from '@components/loyalty-only-warning-modal/loyalty-only-warning-modal.constants';

@Component({
  selector: 'app-loyalty-only-warning-modal',
  standalone: true,
  imports: [CommonModule, AlertModalComponent],
  templateUrl: './loyalty-only-warning-modal.component.html',
  styleUrls: ['./loyalty-only-warning-modal.component.scss']
})
export class LoyaltyOnlyWarningModalComponent {
  @Output() proceeded = new EventEmitter<void>();
  @Output() canceled = new EventEmitter<void>();

  @ViewChild('loyaltyOnlyModal') loyaltyOnlyModal?: AlertModalComponent;

  readonly TEXT = LOYALTY_ONLY_WARNING_MODAL_TEXT;
  private isProceeding = false;

  openModal(): void {
    this.isProceeding = false;
    this.loyaltyOnlyModal?.openModal();
  }

  closeModal(): void {
    this.loyaltyOnlyModal?.closeModal();
  }

  handleProceed(): void {
    this.isProceeding = true;
    this.proceeded.emit();
  }

  handleCancel(): void {
    if (this.isProceeding) {
      this.isProceeding = false;
      return;
    }
    this.canceled.emit();
  }
}
